import { DeliverySchema, PricingRuleModelSchema } from '@hprofits/shared';

export const PRICING_MODELS = PricingRuleModelSchema.options;
export type PricingModelValue = (typeof PRICING_MODELS)[number];

export const DELIVERIES = DeliverySchema.options;
export type DeliveryValue = (typeof DELIVERIES)[number];

// These constants guard against a null/missing row state. They mirror the first
// element of each enum array (the server default), so a missing value serialises
// to a safe no-op value rather than crashing or sending `undefined` to the API.
//
// The non-null assertion is intentional and safe: PricingRuleModelSchema and
// DeliverySchema both have at least one member.
export const DEFAULT_PRICING_MODEL: PricingModelValue = PRICING_MODELS[0]!;
export const DEFAULT_DELIVERY: DeliveryValue = DELIVERIES[0]!;
export const DEFAULT_ROOT_PRICE = 0.1;
